import { useTranslation } from 'react-i18next'

import { DownloadIcon } from '@dhl-ui/icons'
import { useSearchUsersHook } from '@dhl/keycloak-user-api'
import { Button } from '@dhl-ui/components'

import { useCurrentUser } from '~/common'
import { blobFromString, downloadBlob, isSuperDownloadButtonEnabled, usersToCsv } from '~/modules/adminusers/helpers'

const exportFilename = 'admin-users.csv'
const exportCsvType = 'text/csv;charset=utf-8'

export const ExportAdminUsers = () => {
  const user = useCurrentUser()
  const { hasRole } = user
  // only display button when user has ADMIN_USERS role and feature flag is enabled
  const shouldDisplay = hasRole('ADMIN_USERS') && isSuperDownloadButtonEnabled()
  const searchUsers = useSearchUsersHook()
  const { t } = useTranslation()

  /**
   * - gets all admin users
   * - create a blob from the csv string
   */
  const exportUsers = async () => {
    if (shouldDisplay) {
      const users = await searchUsers({
        search: '',
        firstResult: 0,
        maxResult: 1_000,
      })
      const csv = usersToCsv(users)
      downloadBlob(blobFromString(csv, exportCsvType), exportFilename)
    }
  }
  return shouldDisplay ? (
    <Button
      size="large"
      data-testid="add-admin"
      color="primary"
      variant="contained"
      startIcon={<DownloadIcon />}
      onClick={exportUsers}
    >
      {t('admin.adminUsersPage.userHeader.exportUsers')}
    </Button>
  ) : null
}
